/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Exhibition } from '../models/exhibition';
import { ExhibitionWithRelations } from '../models/exhibition-with-relations';
import { inventoryCreateExhibition } from '../fn/inventory-exhibitions-controller/inventory-create-exhibition';
import { InventoryCreateExhibition$Params } from '../fn/inventory-exhibitions-controller/inventory-create-exhibition';
import { inventoryDeleteExhibition } from '../fn/inventory-exhibitions-controller/inventory-delete-exhibition';
import { InventoryDeleteExhibition$Params } from '../fn/inventory-exhibitions-controller/inventory-delete-exhibition';
import { inventoryGetExhibition } from '../fn/inventory-exhibitions-controller/inventory-get-exhibition';
import { InventoryGetExhibition$Params } from '../fn/inventory-exhibitions-controller/inventory-get-exhibition';
import { inventoryGetExhibitions } from '../fn/inventory-exhibitions-controller/inventory-get-exhibitions';
import { InventoryGetExhibitions$Params } from '../fn/inventory-exhibitions-controller/inventory-get-exhibitions';
import { inventoryUpdateExhibition } from '../fn/inventory-exhibitions-controller/inventory-update-exhibition';
import { InventoryUpdateExhibition$Params } from '../fn/inventory-exhibitions-controller/inventory-update-exhibition';
import { moveExhibitionToGlobal } from '../fn/inventory-exhibitions-controller/move-exhibition-to-global';
import { MoveExhibitionToGlobal$Params } from '../fn/inventory-exhibitions-controller/move-exhibition-to-global';

@Injectable({ providedIn: 'root' })
export class InventoryExhibitionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exhibitionControllerMoveExhibitionToGlobal()` */
  static readonly ExhibitionControllerMoveExhibitionToGlobalPath = '/inventory/exhibitions/move-to-global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveExhibitionToGlobal()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveExhibitionToGlobal$Response(params: MoveExhibitionToGlobal$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return moveExhibitionToGlobal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveExhibitionToGlobal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveExhibitionToGlobal(params: MoveExhibitionToGlobal$Params, context?: HttpContext): Observable<any> {
    return this.moveExhibitionToGlobal$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerInventoryGetExhibition()` */
  static readonly ExhibitionControllerInventoryGetExhibitionPath = '/inventory/exhibitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetExhibition()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetExhibition$Response(params: InventoryGetExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitionWithRelations>> {
    return inventoryGetExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetExhibition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetExhibition(params: InventoryGetExhibition$Params, context?: HttpContext): Observable<ExhibitionWithRelations> {
    return this.inventoryGetExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExhibitionWithRelations>): ExhibitionWithRelations => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerInventoryUpdateExhibition()` */
  static readonly ExhibitionControllerInventoryUpdateExhibitionPath = '/inventory/exhibitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryUpdateExhibition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateExhibition$Response(params: InventoryUpdateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryUpdateExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryUpdateExhibition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateExhibition(params: InventoryUpdateExhibition$Params, context?: HttpContext): Observable<any> {
    return this.inventoryUpdateExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerInventoryGetExhibitions()` */
  static readonly ExhibitionControllerInventoryGetExhibitionsPath = '/inventory/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetExhibitions()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetExhibitions$Response(params: InventoryGetExhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitionWithRelations>>> {
    return inventoryGetExhibitions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetExhibitions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetExhibitions(params: InventoryGetExhibitions$Params, context?: HttpContext): Observable<Array<ExhibitionWithRelations>> {
    return this.inventoryGetExhibitions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ExhibitionWithRelations>>): Array<ExhibitionWithRelations> => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerInventoryCreateExhibition()` */
  static readonly ExhibitionControllerInventoryCreateExhibitionPath = '/inventory/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryCreateExhibition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateExhibition$Response(params: InventoryCreateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<Exhibition>> {
    return inventoryCreateExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryCreateExhibition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateExhibition(params: InventoryCreateExhibition$Params, context?: HttpContext): Observable<Exhibition> {
    return this.inventoryCreateExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Exhibition>): Exhibition => r.body)
    );
  }

  /** Path part for operation `exhibitionControllerInventoryDeleteExhibition()` */
  static readonly ExhibitionControllerInventoryDeleteExhibitionPath = '/inventory/exhibitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryDeleteExhibition()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteExhibition$Response(params: InventoryDeleteExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryDeleteExhibition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryDeleteExhibition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteExhibition(params: InventoryDeleteExhibition$Params, context?: HttpContext): Observable<any> {
    return this.inventoryDeleteExhibition$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
